var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjsmodality2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8oxhj0c7a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#yj70v37n5b)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.65.95c.971 0 1.733 0 2.345.056.623.057 1.139.175 1.605.44.766.437 1.39 1.133 1.78 1.99.237.52.343 1.096.394 1.793.05.684.05 1.536.05 2.622v.053c0 1.086 0 1.937-.05 2.621-.051.697-.157 1.273-.394 1.794-.39.856-1.014 1.553-1.78 1.99-.466.265-.982.383-1.605.44-.612.055-1.374.055-2.345.055H9.031v1.452c.442.035.882.113 1.316.234l1.115.311c.285.08.458.402.386.72-.07.318-.36.512-.644.432l-1.115-.311a5.9 5.9 0 0 0-3.178 0l-1.116.311c-.284.08-.573-.114-.644-.432-.071-.318.102-.64.386-.72l1.116-.311a6.882 6.882 0 0 1 1.315-.234v-1.452H6.352c-.972 0-1.734 0-2.346-.056-.623-.056-1.138-.174-1.604-.44-.767-.436-1.39-1.133-1.78-1.99-.238-.52-.343-1.096-.394-1.793-.05-.684-.05-1.535-.05-2.621V7.85c0-1.086 0-1.938.05-2.622.05-.697.156-1.272.394-1.793.39-.857 1.013-1.553 1.78-1.99.466-.265.98-.383 1.604-.44C4.618.95 5.38.95 6.352.95h4.297z",
    fill: "url(#ng3b1b01bc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.65.95c.971 0 1.733 0 2.345.056.623.057 1.139.175 1.605.44.766.437 1.39 1.133 1.78 1.99.237.52.343 1.096.394 1.793.05.684.05 1.536.05 2.622v.053c0 1.086 0 1.937-.05 2.621-.051.697-.157 1.273-.394 1.794-.39.856-1.014 1.553-1.78 1.99-.466.265-.982.383-1.605.44-.612.055-1.374.055-2.345.055H9.031v1.452c.442.035.882.113 1.316.234l1.115.311c.285.08.458.402.386.72-.07.318-.36.512-.644.432l-1.115-.311a5.9 5.9 0 0 0-3.178 0l-1.116.311c-.284.08-.573-.114-.644-.432-.071-.318.102-.64.386-.72l1.116-.311a6.882 6.882 0 0 1 1.315-.234v-1.452H6.352c-.972 0-1.734 0-2.346-.056-.623-.056-1.138-.174-1.604-.44-.767-.436-1.39-1.133-1.78-1.99-.238-.52-.343-1.096-.394-1.793-.05-.684-.05-1.535-.05-2.621V7.85c0-1.086 0-1.938.05-2.622.05-.697.156-1.272.394-1.793.39-.857 1.013-1.553 1.78-1.99.466-.265.98-.383 1.604-.44C4.618.95 5.38.95 6.352.95h4.297z",
    stroke: "url(#me4nwgv5md)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#as4h0utame)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.969 11.836c0 .328.238.593.531.593h4.25c.293 0 .531-.265.531-.593 0-.328-.238-.594-.531-.594H8.5c-.293 0-.531.266-.531.594zm-2.302 0c0 .437-.317.791-.709.791-.39 0-.708-.354-.708-.791 0-.438.317-.792.708-.792.392 0 .709.354.709.792z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ng3b1b01bc",
    x1: 8.501,
    y1: 0.95,
    x2: 8.501,
    y2: 17.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "me4nwgv5md",
    x1: 0.178,
    y1: 0.95,
    x2: 17.203,
    y2: 17.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "yj70v37n5b",
    x: -24.572,
    y: -23.8,
    width: 66.147,
    height: 66.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2555",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "as4h0utame",
    x: 1.25,
    y: 8.044,
    width: 25.031,
    height: 17.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_2555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_2555",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8oxhj0c7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v19H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsmodality2);
export default __webpack_public_path__ + "static/media/Bootcamp js modality 2.0033bee29c186b82fdce639f5683731a.svg";
export { ForwardRef as ReactComponent };